module.exports = __webpack_public_path__ + "img/title-bg.d3509bf5.png";